<template>
  <div class="home">
    <div style="position: fixed; width: 100%; z-index: 2">
      <div style="background-color: #fff; padding: 0 12px; display: flex; align-items: center; height: 40px;">
        <input type="text" class="my-input" placeholder="请输入赛事名称" v-model="chineseName">
        <van-button style="height: 36px; width: 88px;" type="info" @click="search">搜 索</van-button>
      </div>
      <div class="tabs">
        <div class="tab" @click="showAreaFun">
          <span class="info">{{ areaValue }}</span>
          <div class="selected" v-if="showArea"></div>
          <div class="disSelected" v-else></div>
        </div>
        <div class="tab" @click="showSportTypeFun">
          <span class="info">{{ sportType }}</span>
          <div class="selected" v-if="showSportType"></div>
          <div class="disSelected" v-else></div>
        </div>
        <div class="tab" @click="showStateFun">
          <span class="info">{{ stateValue }}</span>
          <div class="selected" v-if="showState"></div>
          <div class="disSelected" v-else></div>
        </div>
      </div>
    </div>
    <div style="height: 82px;"></div>
    <div class="match-list">
      <div class="list">
        <van-list
            v-model="loading"
            :finished="finished"
            finished-text="没有更多了"
            @load="getCrmMerchantUnionMatchList"
        >
          <div class="item" v-for="(item, index) in list" :key="index" @click="goMatch(item.state, item.id)">
            <div class="bgi" :style="{'background-image': `url(${imageView(item.backgroundImage2, 'default', 143)})`}">
              <div class="state" >{{ item.state }}</div>
              <div class="match-name">
                <img src="../../assets/match_01.png" style="width: 16px; height: 16px; margin-right: 6px;">
                <div class="name">{{ item.chineseName }}</div>
              </div>
            </div>
            <div class="match-info">
              <div class="location" v-if="item.city">{{ `${item.province}-${item.city}` }}</div>
              <div class="location" v-else>{{ `${item.province}` }}</div>
              <div class="time">
                <div class="time-info">比赛时间：{{ getFormatDate(item.beginDate) }}&nbsp;~&nbsp;{{ getFormatDate(item.beginDate) }}</div>
                <img src="../../assets/grey-right.png" style="width: 13px; height: 13px;">
              </div>
            </div>
          </div>
        </van-list>
      </div>
    </div>
    <div style="height: 88px;"></div>
    <div class="bottom">
      <div class="btn match-manage" @click="goManageMatchList">赛事管理</div>
      <div class="btn my-btn" @click="goMyEntryList">我的参赛</div>
    </div>
    <div class="popup">
      <van-popup v-model="showArea" position="bottom" :style="{ height: '40%' }" >
        <van-picker
            title="请选择城市"
            show-toolbar
            :columns="areaValueOptions"
            @confirm="onConfirmArea"
            @cancel="onCancelArea"
        />
      </van-popup>
      <van-popup v-model="showSportType" position="bottom" :style="{ height: '40%' }" >
        <van-picker
            title="请选择项目"
            show-toolbar
            :columns="sportsList"
            @confirm="onConfirmSport"
            @cancel="onCancelSport"
        />
      </van-popup>
      <van-popup v-model="showState" position="bottom" :style="{ height: '40%' }" >
        <van-picker
            title="请选择状态"
            show-toolbar
            :columns="stateValueOptions"
            @confirm="onConfirm"
            @cancel="onCancel"
        />
      </van-popup>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import { List, Picker, Popup, Button } from 'vant'
Vue.use(List).use(Picker).use(Popup).use(Button)
import {
  getHome,
  getCrmMerchantUnionMatchList, getAreaTreeList
} from '@/api/match'
import { DateUtil, QNImageUtil } from '@/utils'

const stateOptions = [
  { value: 0, label: '全部' },
  { value: 2, label: '报名中' },
  { value: 5, label: '进行中' },
  { value: 6, label: '已完赛' }
]
const stateValueOptions = [ '全部', '报名中', '进行中', '已完赛' ]

export default {
  data() {
    return {
      stateValueOptions: stateValueOptions,
      merchantId: '',
      finished: true,
      loading: false,
      list: [],
      areaId: '4669',
      areaValue: '山东',
      sportType: '项目',
      stateValue: '状态',
      state: '',
      showState: false,
      sportsList: [],
      showSportType: false,
      pageSize: 10,
      pageNum: 1,
      showArea: false,
      areaOptions: [{ name: '山东', id: '4669' }],
      areaValueOptions: ['山东'],
      chineseName: ''
    }
  },
  watch: {
    chineseName() {
      this.search()
    }
  },
  mounted() {
    this.merchantId = this.$route.params.id
    this.getHome()
    this.getAreaTreeList()
    this.getCrmMerchantUnionMatchList()
  },
  methods: {
    getAreaTreeList() {
      getAreaTreeList().then(res => {
        if (res) {
          const { data } = res
          const option = JSON.parse(data.list.list.replaceAll("'", '"'))
          const sd = []
          option.forEach(item => {
            if (item.name === '山东') {
              item.kids.forEach(i => {
                sd.push({
                  name: i.name,
                  id: i.id
                })
                this.areaValueOptions.push(i.name)
              })
            }
          })
          this.areaOptions = this.areaOptions.concat(sd)
        }
      })
    },
    getHome() {
      getHome().then(res => {
        if (res) {
          const sportsList = ['全部']
          const list = res.data.apps
          list.forEach(item => {
            sportsList.push(item.name)
          })
          this.sportsList = sportsList
        }
      })
    },
    search() {
      this.pageNum = 1
      this.list = []
      this.getCrmMerchantUnionMatchList()
    },
    getCrmMerchantUnionMatchList() {
      const params = {
        merchantId: this.merchantId,
        sportType: this.sportType === '项目' ? '' : this.sportType,
        state: this.state,
        pageSize: this.pageSize,
        pageNum: this.pageNum,
        chineseName: this.chineseName
      }
      if (this.areaValue === '山东') {
        params.provinceId = '4669'
      } else {
        params.areaId = this.areaId
      }
      getCrmMerchantUnionMatchList(params).then(res => {
        if (res) {
          this.pageNum++
          const { data } = res
          const list = data.list || []
          this.list = this.list.concat(list)
          if (this.list.length < this.pageSize) {
            this.finished = true
          }
          this.$forceUpdate()
        }
      })
    },
    getFormatDate(date) {
      if (!date) return ''
      return DateUtil.parseDateTime(date, '{y}/{m}/{d}')
    },
    goMatch(state, id) {
      this.$router.push(`/union-match?unionMatchId=${id}`)
      // this.$router.push(`/union-match?unionMatchId=${id}&merchantId=${this.merchantId}`)
      // if (state === '可报名') {
      //   this.$router.push(`/entry-page?unionMatchId=${id}&merchantId=${this.merchantId}`)
      // } else {
      //
      // }
    },
    imageView(img, w, h) {
      if (!img) return ''
      if (w === 'default') w = window.innerWidth - 24
      else w = ''
      return QNImageUtil.imageView(img, w, h)
    },
    showStateFun() {
      this.showState = true
    },
    showSportTypeFun() {
      this.showSportType = true
    },
    showAreaFun() {
      this.showArea = true
    },
    onConfirm(value) {
      stateOptions.forEach(item => {
        if (item.label === value) {
          this.state = item.value
        }
      })
      this.stateValue = value === '全部' ? '状态' :  value
      this.showState = false
      this.list = []
      this.pageSize = 10
      this.pageNum = 1
      this.getCrmMerchantUnionMatchList()
    },
    onCancel() {
      this.showState = false
    },
    onConfirmSport(value) {
      stateOptions.forEach(item => {
        if (item.label === value) {
          this.state = item.value
        }
      })
      this.sportType = value === '全部' ? '项目' :  value
      this.showSportType = false
      this.list = []
      this.pageSize = 10
      this.pageNum = 1
      this.getCrmMerchantUnionMatchList()
    },
    onCancelSport() {
      this.showState = false
    },
    goMyEntryList() {
      this.$router.push('/merchant/attend-list/' + this.merchantId)
    },
    goManageMatchList() {
      this.$router.push('/merchant/manage-match-list/' + this.merchantId)
    },
    onConfirmArea(value) {
      this.areaOptions.forEach(item => {
        if (item.name === value) {
          this.areaId = item.id
        }
      })
      this.areaValue = value
      this.showArea = false
      this.list = []
      this.pageSize = 10
      this.pageNum = 1
      this.getCrmMerchantUnionMatchList()
    },
    onCancelArea() {
      this.showArea = false
    },
  }
}
</script>

<style lang="scss" scoped>
.home {
  min-height: 100vh;
  background-color: #F6F6F8;
  .my-input {
    width: calc(100vw - 124px);
    -webkit-appearance: none;
    background-color: #FFFFFF;
    background-image: none;
    border-radius: 4px;
    border: 1px solid #DCDFE6;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    color: #606266;
    display: inline-block;
    font-size: 13px;
    height: 36px;
    line-height: 36px;
    outline: none;
    padding: 0 15px;
    transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
    margin-right: 12px;
  }
  .tabs {
    background-color: #FFFFFF;
    padding: 0 12px;
    display: flex;
    justify-content: space-between;
    .tab {
      width: calc(33% - 12px);
      height: 38px;
      display: flex;
      align-items: center;
      justify-content: center;
      .info {
        margin-right: 6px;
        font-size: 14px;
        color: #191919;
      }
      .selected {
        border-top: 5px #1565FC solid;
        border-right: 4px #FFFFFF solid;
        border-left: 4px #FFFFFF solid;
      }
      .disSelected {
        border-right: 4px #FFFFFF solid;
        border-bottom: 5px #E4E5EE solid;
        border-left: 4px #FFFFFF solid;
      }
      .info {
        font-size: 14px;
        color: #191919;
      }
    }
  }
  .match-list {
    padding: 0 12px;
    margin-top: 12px;
    .title {
      height: 49px;
      color: #191919;
      font-size: 16px;
      font-weight: bolder;
      display: flex;
      align-items: center;
      justify-content: center;
      border-bottom: 1px #F2F2F2 solid;
    }
    .list {
      .item {
        padding-top: 12px;
        margin-bottom: 12px;
        background-color: #FFFFFF;
        border-radius: 8px;
        .bgi {
          margin: 0 12px;
          position: relative;
          border-radius: 4px;
          overflow: hidden;
          height: 133px;
          background-size: 100% 100%;
          .state {
            width: 50px;
            height: 20px;
            line-height: 20px;
            text-align: center;
            background-color: #12DB63;
            color: #FFFFFF;
            font-size: 12px;
            border-radius: 4px 0 4px 0;
          }
          .match-name {
            position: absolute;
            bottom: 0;
            height: 36px;
            width: 100%;
            color: #FFFFFF;
            font-size: 14px;
            display: flex;
            align-items: center;
            padding: 0 12px;
            background: linear-gradient(180deg, rgba(0,0,0,0) 0%, rgba(0,0,0,0.8) 100%);
            .name {
              width: 88%;
              overflow:hidden;
              text-overflow: ellipsis;
              -webkit-line-clamp: 2;
              display: -webkit-box;
              -webkit-box-orient: vertical;
            }
          }
        }
        .match-info {
          box-sizing: border-box;
          height: 48px;
          display: flex;
          padding: 12px;
          align-items: center;
          .location {
            width: 64px;
            height: 24px;
            line-height: 24px;
            background-color: #E7EFFE;
            border-radius: 4px;
            color: #1565FC;
            font-size: 11px;
            text-align: center;
            overflow: hidden;
            text-wrap: none;
            margin-right: 12px;
          }
          .time {
            display: flex;
            align-items: center;
            .time-info {
              color: #8C8C8C;
              font-size: 13px;
              width: calc(100vw - 140px);
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
            }
          }
        }
      }
    }
  }
  .bottom {
    width: 100vw;
    height: 74px;
    position: fixed;
    bottom: 0;
    left: 0;
    box-sizing: border-box;
    padding: 0 12px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: #FFFFFF;
    .btn {
      width: calc(50vw - 18px);
      height: 46px;
      border-radius: 4px;
      font-size: 14px;
      font-weight: 500;
      line-height: 46px;
      text-align: center;
    }
    .match-manage {
      background-color: #F3F7FB;
      color: #1565FC;
    }
    .my-btn {
      background-color: #1565FC;
      color: #FFFFFF;
    }
  }
}
</style>
